<template>
  <router-link
      :to="to"
      custom
      v-slot="{href, navigate, isActive }">
    <li class="transition-all w-full h-20 my-20 px-4 py-2" :class="isActive ? 'active text-white' : 'text-accent'">
      <a :href="href" @click="navigate">
        <div :class="{'relative inline-block bg-accent custom-shadow p-4 rounded-xl z-10' : isActive}">
          <slot></slot>
        </div>
      </a>
    </li>
  </router-link>


</template>

<script>
export default {
  name: "SideMenuItem",
  props: ['to'],
}
</script>

<style scoped>
li.active {
  position: relative;
  @apply bg-dark rounded-tr-xl rounded-br-xl w-full mr-3
}

.active:before {
  content: "";
  position: absolute;
  top: -40px;
  left: 12px;
  height: 40px;
  width: 40px;
  border-bottom-left-radius: 50%;
  box-shadow: 0 20px 0 0 theme('colors.dark.DEFAULT');
  @apply bg-dark-foreground
}

.active:after {
  content: "";
  position: absolute;
  bottom: -40px;
  left: 12px;
  height: 40px;
  width: 40px;
  border-top-left-radius: 50%;
  box-shadow: 0 -20px 0 0 theme('colors.dark.DEFAULT');
  @apply bg-dark-foreground
}
</style>